var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRollingControlSum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.78 2.9 4.95 5.03-5.14 5.17H12V16H0v-2.49l5.65-5.8L.32 2.48V0h11.47v2.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRollingControlSum);
export default __webpack_public_path__ + "static/media/rolling-control-sum.3b1c8a50f2b9096190463fae717db250.svg";
export { ForwardRef as ReactComponent };